module.exports = __webpack_public_path__ + "school/img/region_workstation_bg.cdb2cffe.jpg";